<template>
    <div v-if="item?.label" class="key-value">
        <h5>{{ item.label }}</h5>
        <p v-html="displayValue()"></p>
    </div>
</template>

<script setup>
import { defineProps, toRefs } from 'vue';
const props = defineProps(['item']);
const { item } = toRefs(props);
function displayValue(){
    let returnReponse = '';
    if(item.value?.value){
        returnReponse =  item.value.value;
        if(item.value.type === 'referenceLoadMultiSelect'){
            returnReponse = '';
            item.value.value.forEach((element, index) => {
                returnReponse += element.value;
                if (index < item.value.value.length - 1) {
                    returnReponse += ', ';
                }
            });
        }
    }
    switch (item.value?.issue) {
        case 'noData':
            return "<em style='font-size:12px;'>No data available</em>";
        case 'noPermission':
            return "<em style='font-size:12px;'>Insufficient permission</em>";
    }
    const sanitizedText = sanitizeText(returnReponse);
    const formattedText = formatLineBreaks(sanitizedText);
    return formattedText;
}
function sanitizeText(input) {
    const parser = new DOMParser();
    const parsedDocument = parser.parseFromString(input, 'text/html');
    const sanitizedText = parsedDocument.body.textContent || '';
    return sanitizedText;
}
function formatLineBreaks(input) {
    return input.replace(/\r\n|\r|\n/g, '<br>');
}
</script>
  